module.exports = __webpack_public_path__ + "img/course107_curriculum.26bf6863.png";